import React from 'react';
import TabBootstrapContainer from '../../Componant/UiKits/Tabs';

const TabBootstrap = () => {
  return (
    <div className='page-body'>
      <TabBootstrapContainer />
    </div>
  );
};

export default TabBootstrap;
